<template>
<div>
  <el-row type="flex" justify="space-between" class="title-bar vertical-center-box">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">{{title}}</div>
      <w-auto-reload-button v-if="eventType==='status'" class="mr-l4" task-name="eventStatusTask" :active="active" @load-data="loadData"/>
      <el-button size="mini" class="mr-l4 mr-r4" :disabled="selectedRowArray.length === 0" @click="clickConfirmManagerStatus()">일괄확인</el-button>
      <el-button v-if="eventType==='status'" size="mini" :disabled="groupReleaseButtonDisableFlag" @click="clickReleaseButton()">일괄해제</el-button>
    </div>
    <div class="vertical-center-box">
      <el-button size="small" @click="exportExcel" class="mr-r4"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
    </div>
  </el-row>
  <el-row>
    <el-table-wrapper v-loading="isLoading" style="width:100%;" ref="eventTable" border header-align="center" :data="eventTableData" :columns="eventTableColumns" pagination :total="total"
      :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadData" @selection-change="changeHandleSelection" remote>
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
      </template>
      <template slot-scope="scope" slot="pre-eventlevel-slot">
        <w-eventlevel-cell type="background" v-if="scope.row.statusChangeDatetime !== undefined && scope.row.statusChangeDatetime !== null" :eventlevel-id="scope.row.preEventlevelId">
          <span slot="content">{{getDateFormatter(scope, scope, scope.row.statusChangeDatetime)}}</span>
        </w-eventlevel-cell>
        <span v-else>{{emptyText}}</span>
      </template>
      <template slot-scope="scope" slot="release-slot">
        <el-button v-if="scope.row.managetypeId !== 'SVC'" size="mini" @click="clickReleaseButton(scope.row)">해제</el-button>
        <span v-else>{{emptyText}}</span>
      </template>
      <template slot-scope="scope" slot="trouble-ticket-group-id-slot">
        <span v-if="scope.row.troubleTicketGroupId == null">-</span>
        <span v-else class="link c-pointer" @click="clickTroubleTicketGroupId(scope.row.troubleTicketGroupId)">{{scope.row.troubleTicketGroupId}}</span>
      </template>
      <template slot-scope="scope" slot="confirm-manager-slot">
        <span v-if="scope.row.confirmManagerId">{{scope.row.confirmManagerId}} ( {{getDateFormatter(scope, scope, scope.row.confirmDatetime)}} )</span>
        <span v-else-if="scope.row.confirmManagerId">{{scope.row.confirmManagerId}} ( {{getDateFormatter(scope, scope, scope.row.confirmDatetime)}} )</span>
        <span v-else class="link c-pointer" @click="clickConfirmManagerStatus(scope.row)">미확인</span>
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{scope.row.eventMessage}}</span>
      </template>
      <template slot-scope="scope" slot="release-hist-slot">
        <span v-if="scope.row.releaseDatetime == null">미해제</span>
        <!-- add 1210 display-exceptional ie friendly -->
        <el-button class="display-exceptional" v-else-if="scope.row.releaseManagerId == null" size="mini" @click="clickReleaseHistButton(scope.row, 'auto')">자동</el-button>
        <el-button class="display-exceptional" v-else size="mini" @click="clickReleaseHistButton(scope.row, 'manual')">수동</el-button>
      </template>
      <template slot-scope="scope" slot="root-cause-slot">
        <span v-if="scope.row.rootCauseFlag === 'N'"> - </span>
        <span v-else-if="scope.row.rootCauseFlag === 'E'"><i class="fas fa-circle" @click="onClickRootCause(scope.row)" style="color:#ff4451;cursor:pointer" ></i></span>
        <span v-else-if="scope.row.rootCauseFlag === 'A'"><i class="fas fa-circle" @click="onClickRootCause(scope.row)" style="color:#476fd5;cursor:pointer" ></i></span>
      </template>
      <template #obj-name-slot="scope">
        <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
        <span v-else>-</span>
      </template>
    </el-table-wrapper>
    <w-event-release-popup ref="releasePopup" :event-data="releaseEventList" @reload="loadData" />
    <w-event-ticket-status-popup ref="statusPop" :isReadOnlyTicket="true" :trouble-ticket-info="troubleTicketInfo" @create-pop-from-event-status-pop="createPopFromEventStatusPop" @load-data="loadData" />
    <w-event-ticket-report-popup ref="reportRefPop" :trouble-ticket-info="troubleTicketInfo" @click-trouble-ticket-group-id="clickTroubleTicketGroupId"
      @load-data="loadData" :trouble-ticket-group-info-list="troubleTicketGroupInfoList" />
    <w-event-release-hist-popup ref="releaseHistPopup" :event-data="eventData" :release-hist-type="releaseHistType" />
    <w-root-cause-analysis-popup ref="rootCuaseAnalysisPopup" />
  </el-row>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { map, isNil, isEqual, isEmpty, filter, forEach, clone, cloneDeep, has, findIndex } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString, getDuration } from '@/utils/date';
import messageUtil from '@/utils/message';
import { openFaultAnalysisPopup } from '@/utils/event';
import EventStatusAPI from '@/api/event/event-status';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import EventHistAPI from '@/api/event/event-hist';
import FileApi from '@/api/common/file';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WAutoReloadButton from '@/components/button/AutoReloadButton';
import WEventReleasePopup from '@/views/event/event-status/popup/EventReleasePopup';
import WEventTicketStatusPopup from '@/views/event/components/popup/EventTicketStatusPopup';
import WEventStatusHistPopup from '@/views/event/components/popup/EventStatusHistPopup';
import WEventTicketReportPopup from '@/views/event/components/popup/EventTicketReportPopup';
import WEventReleaseHistPopup from '@/views/event/event-hist/popup/EventReleaseHistPopup';
import WRootCauseAnalysisPopup from '@/views/event/event-hist/popup/RootCauseAnalysisPopup/index';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

export default {
  name: 'WEventCommonTable',
  components: {
    WEventlevelCell,
    WAutoReloadButton,
    WEventReleasePopup,
    WEventTicketStatusPopup,
    WEventStatusHistPopup,
    WEventTicketReportPopup,
    WEventReleaseHistPopup,
    WRootCauseAnalysisPopup,
  },
  props: {
    eventType: String,
    active: Boolean,
    filterParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      eventStatusTask: 'eventStatusTask',
      emptyText: EMPTY_TEXT,
      eventData: null,
      releaseEventList: null,
      eventTableColumns: [],
      showSearchTool: false,
      eventTableData: null,
      eventTableColums: null,
      selectedRowArray: [],
      troubleTicketInfo: null,
      troubleTicketGroupInfoList: [],
      eventStatusHistData: [],
      shootingHistData: [],
      releaseHistType: null,
      rscDatatypeId: null,
      rscUnits: [],
      total: 0,
      isLoading: false,
      managetypeList: [],
      eventStatusColumns: [
        {
          type: 'selection',
          width: 43,
        },
        {
          prop: 'eventlevelName',
          label: '등급',
          width: 95,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevelMulti',
          remoteProp: 'eventlevelId',
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 100,
          headerAlign: 'center',
          filters: [
          ],
        },
        {
          prop: 'objName',
          label: '대상',
          width: 110,
          headerAlign: 'center',
          formatter: this.getTargetInfo,
          searchable: true,
          scopedSlot: 'obj-name-slot',
          remoteProp: 'targetInfo',
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 100,
          headerAlign: 'center',
          searchable: true,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          searchable: true,
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
        },
        {
          label: '이벤트 발생',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'checkDatetime',
              label: '최초발생시각',
              width: 130,
              headerAlign: 'center',
              searchType: 'date',
              searchable: true,
              formatter: this.getDateFormatter,
            },
            {
              prop: 'duration',
              label: '지속시간',
              width: 150,
              headerAlign: 'center',
              formatter: this.getEventDuration,
            },
            {
              prop: 'statusChangeDatetime',
              label: '상태변경시각',
              width: 124,
              headerAlign: 'center',
              searchType: 'date',
              searchable: true,
              scopedSlot: 'pre-eventlevel-slot',
            },
            {
              prop: 'confirmManagerId',
              label: '확인자',
              width: 80,
              headerAlign: 'center',
              searchable: true,
              scopedSlot: 'confirm-manager-slot',
            },
          ],
        },
        {
          label: '장애티켓 발생',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'troubleStatusName',
              label: '처리현황',
              width: 80,
              headerAlign: 'center',
              formatter: this.convertStatusName,
              filters: [
                {
                  text: '미처리',
                  value: 'empty',
                },
                {
                  text: '처리 중',
                  value: 'R',
                },
                {
                  text: '처리 완료',
                  value: 'E',
                },
              ],
              remoteProp: 'troubleStatus',
            },
            {
              prop: 'troubleTicketGroupId',
              label: '장애티켓',
              width: 65,
              scopedSlot: 'trouble-ticket-group-id-slot',
              headerAlign: 'center',
              searchable: true,
            },
            {
              prop: 'lastEditerId',
              label: '처리자',
              width: 65,
              headerAlign: 'center',
              searchable: true,
              formatter: this.getValueAfterCheckEmpty,
            },
          ],
        },
        {
          label: '수동해제',
          width: 70,
          align: 'center',
          scopedSlot: 'release-slot',
        },
      ],
      eventHistColumns: [
        {
          type: 'selection',
          width: 43,
        },
        {
          prop: 'eventlevelName',
          label: '등급',
          width: 95,
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          searchable: true,
          searchType: 'eventlevelMulti',
          remoteProp: 'eventlevelId',
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 110,
          headerAlign: 'center',
          filters: [
          ],
        },
        {
          prop: 'objName',
          label: '대상',
          width: 110,
          headerAlign: 'center',
          formatter: this.getTargetInfo,
          searchable: true,
          remoteProp: 'targetInfo',
          scopedSlot: 'obj-name-slot',
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          width: 100,
          headerAlign: 'center',
          searchable: true,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          searchable: true,
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
        },
        {
          label: '이벤트 발생',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'checkDatetime',
              label: '최초발생시각',
              width: 130,
              headerAlign: 'center',
              searchType: 'date',
              searchable: true,
              formatter: this.getDateFormatter,
            },
            {
              prop: 'duration',
              label: '지속시간',
              width: 120,
              headerAlign: 'center',
              formatter: this.getEventDuration,
            },
            {
              prop: 'releaseDatetime',
              label: '해제시각',
              width: 130,
              headerAlign: 'center',
              searchType: 'date',
              searchable: true,
              formatter: this.getDateFormatter,
            },
            {
              prop: 'confirmManagerId',
              label: '확인자',
              width: 80,
              headerAlign: 'center',
              searchable: true,
              scopedSlot: 'confirm-manager-slot',
            },
          ],
        },
        {
          label: '장애티켓 발생',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'troubleStatusName',
              label: '처리현황',
              width: 80,
              headerAlign: 'center',
              filters: [
                {
                  text: '미처리',
                  value: 'empty',
                },
                {
                  text: '처리 중',
                  value: 'R',
                },
                {
                  text: '처리 완료',
                  value: 'E',
                },
              ],
              formatter: this.getValueAfterCheckEmpty,
              remoteProp: 'troubleStatus',
            },
            {
              prop: 'troubleTicketGroupId',
              label: '장애티켓',
              width: 70,
              scopedSlot: 'trouble-ticket-group-id-slot',
              headerAlign: 'center',
              searchable: true,
              formatter: this.getValueAfterCheckEmpty,
            },
            {
              prop: 'lastEditerId',
              label: '처리자',
              width: 80,
              headerAlign: 'center',
              searchable: true,
              formatter: this.getValueAfterCheckEmpty,
            },
          ],
        },
        {
          prop: 'rootCauseFlag',
          label: '핵심장애',
          width: 75,
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'root-cause-slot',
          filters: [
            {
              text: '핵심',
              value: 'E',
            },
            {
              text: '일반',
              value: 'N',
            },
          ],
        },
        {
          prop: 'releaseType',
          label: '해제이력',
          width: 65,
          align: 'center',
          scopedSlot: 'release-hist-slot',
          filters: [
            {
              text: '미해제',
              value: 'empty',
            },
            {
              text: '자동 해제',
              value: 'auto',
            },
            {
              text: '수동 해제',
              value: 'manual',
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'analysisDateParams', 'activeTab']),
    title() {
      return this.eventType === 'status' ? '이벤트 현황' : '이벤트 이력';
    },
    customerId() {
      return this.$store.state.common.customerId;
    },
    groupReleaseButtonDisableFlag() {
      if (isEmpty(this.selectedRowArray)) {
        return true;
      }
      if (this.selectedRowArray.length === 1 && this.selectedRowArray[0].managetypeId === 'SVC') {
        return true;
      }
      return false;
    },
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        // 라우터로 이벤트 화면 접속 시 eventTable를 찾지 못하므로 nextTick사용.
        this.$nextTick(() => {
          // 필터링에 따라 조회 시 테이블 필터링, 페이징 초기화
          this.$refs.eventTable.clearFilter();
          this.loadData();
        });
        this.selectedRowArray = []; // node 변경 시 선택한 row들이 담긴 배열 초기화
      },
    },
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
    },
    analysisDateParams() {
      if (isEqual(this.eventType, 'hist')) {
        // 필터링에 따라 조회 시 테이블 필터링, 페이징 초기화
        this.$refs.eventTable.clearFilter();
        this.loadData();
      }
    },
    customerId() {
      this.setEventTableColumns();
      this.loadData();
    },
    filterParams() {
      // 필터링에 따라 조회 시 테이블 필터링, 페이징 초기화
      this.$refs.eventTable.clearFilter();
      this.loadData();
    },
  },
  methods: {
    getManagetypeList() {
      const returnList = [];
      const managetypeList = filter(this.$store.getters.activeManagetypes, (item) => isTrue(item.showFlag));
      if (isNil(managetypeList)) {
        this.getManagetypeList();
      } else {
        map(managetypeList, (row) => {
          returnList.push({
            text: row.managetypeName,
            value: row.managetypeName,
          });
        });
      }
      this.managetypeList = returnList;
    },
    getValueAfterCheckEmpty(row, colum, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 이벤트 선택 변경 이벤트 핸들러
     * @param  {[type]} selectVal [description]
     * @return {[type]}           [description]
     */
    changeHandleSelection(selectVal) {
      this.$store.dispatch('setSelectedEvents', selectVal);
      this.selectedRowArray = selectVal;
    },
    setEventTableColumns() {
      const customerId = this.customerId;
      const statusColumns = this.eventStatusColumns.filter((item) => isNil(item.customerId) || (!isNil(item.customerId) && item.customerId === customerId));
      const histColumns = this.eventHistColumns.filter((item) => isNil(item.customerId) || (!isNil(item.customerId) && item.customerId === customerId));
      this.eventTableColumns = [];
      this.getManagetypeList();
      this.$nextTick(() => {
        this.eventTableColumns = this.eventType === 'status' ? statusColumns : histColumns;
        const managetypeNameIdx = findIndex(this.eventTableColumns, ((column) => column.prop === 'managetypeName'));
        this.eventTableColumns[managetypeNameIdx].filters = this.managetypeList;
      });
    },
    /**
     * 이벤트 현황 또는 이력 데이터를 로드한다.
     */
    loadData() {
      if (isEmpty(this.eventTableColumns)) {
        this.setEventTableColumns();
      }
      if (isNil(this.active) || !this.active) {
        return;
      }
      if (isNil(this.selectedNode) || isNil(this.selectedNode.type)) {
        return;
      }
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const headerSearchParams = this.getHeaderSearchParams();
      const params = {
        treeType,
        customerId: this.customerId,
        type: this.selectedNode.type,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        filterParams: this.filterParams,
        headerSearchParams,
        ...headerSearchParams,
      };
      delete params.eventlevelId;

      if (isEqual(treeType, 'logical')) {
        if (isEqual(params.type, 'group')) {
          if (this.selectedNode.subType === 'virtual') {
            params.objId = this.selectedNode.objId;
            params.objtypeId = this.selectedNode.obj.objtypeId;
            params.subType = this.selectedNode.subType;
          } else if (this.selectedNode.subType === 'tier') {
            params.subType = this.selectedNode.subType;
            params.tierId = this.selectedNode.tierId;
          } else {
            params.managegroupIds = this.selectedNode.childManagegroupIds;
          }
        } else if (isEqual(params.type, 'obj')) {
          params.objId = this.selectedNode.obj.objId;
        }
      } else if (isEqual(treeType, 'physical')) {
        params.managetypeId = this.selectedNode.managetypeId;
        if (isEqual(params.type, 'group')) {
          params.objtypeId = this.selectedNode.objtypeId;
          // nms일 경우
          params.objCompanyId = this.selectedNode.objCompanyId;
          // vms일 경우
          params.hypervisorType = this.selectedNode.hypervisorType;
          params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          params.objId = this.selectedNode.objId;
          params.subType = this.selectedNode.subType;
        } else if (isEqual(params.type, 'obj')) {
          params.objId = this.selectedNode.obj.objId;
        }
      }
      if (isEqual(this.eventType, 'status')) {
        this.isLoading = true;
        EventStatusAPI.getEventStatusList(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.eventTableData = result.data;
            this.total = result.total;
          } else {
            this.eventTableData = [];
            this.total = 0;
          }
          this.$nextTick(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.eventTableData = [];
          this.total = 0;
        });
      } else {
        this.isLoading = true;
        EventHistAPI.getEventHistList(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.eventTableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.eventTableData = [];
            this.total = 0;
          }
          this.$nextTick(() => {
            this.isLoading = false;
          });
        }).catch(() => {
          this.eventTableData = [];
          this.total = 0;
          this.isLoading = false;
        });
      }
      if (this.selectedRowArray.length > 0) {
        const eventTable = this.$refs.eventTable;
        eventTable.$children[0].clearSelection();
        this.selectedRowArray = []; // 선택한 row들 내역 초기화
      }
    },
    /**
     * 헤더 검색 파라미터를 이벤트 검색 조건에 맞게 가공하여 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getHeaderSearchParams() {
      const tableParams = this.$refs.eventTable.getParameter();
      const params = {
        ...tableParams,
      };

      if (!isEmpty(tableParams.searchParams)) {
        forEach(tableParams.searchParams, (item) => {
          params[item.field] = item.value;
        });
      }

      if (!isEmpty(tableParams.dateSearchParams)) {
        forEach(tableParams.dateSearchParams, (item) => {
          params[`${item.field}Start`] = item.start;
          params[`${item.field}End`] = item.end;
        });
      }

      // 불필요 데이터
      delete params.searchParams;
      delete params.dateSearchParams;

      return isEmpty(params) ? null : params;
    },
    /**
     * 대상 정보를 반환한다.
     * 수정 시 다음 vue도 함께 수정한다.
     * → 동일한 함수 쓰는 곳: SmartAnalyzerPopup, EventTicketAddPopup
     *
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTargetInfo(row, column, value) {
      if (row.objDefineId === 'NETINTERFACE') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.parentObjName)}/${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      if (row.objDefineId !== 'SERVICE' && row.objDefineId !== 'E2E_SERVICE' && row.objDefineId !== 'FMS_SENSOR') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 날짜를 지정한 포맷으로 변환한다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 이벤트의 지속 시간을 계산한다. (최초 발생시각 ~ 현재 동안의 시간)
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getEventDuration(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDuration(value);
    },
    // getConfirmUser(row, column, value) {
    //   if (!isNil(value)) {
    //     return value; // 확인시각 어디에 등록??
    //   }
    //   return '미확인';
    // },
    /**
     * 헤더 검색 컴포넌트 제공 여부 설정
     */
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 해제 버튼 클릭 시 이벤트 수동 해제 팝업을 띄운다.
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickReleaseButton(row) {
      const eventStatusList = [];
      if (isNil(row)) {
        const selectedRow = clone(this.selectedRowArray);
        selectedRow.forEach((item) => {
          const eventStatus = clone(item);
          eventStatus.targetInfo = this.getTargetInfo(item, null, item.objName);
          eventStatusList.push(eventStatus);
        });
      } else {
        const eventStatus = clone(row);
        eventStatus.targetInfo = this.getTargetInfo(row, null, row.objName);
        eventStatusList.push(eventStatus);
      }
      this.releaseEventList = eventStatusList;
      this.$refs.releasePopup.$refs.slidingPopup.visible = true;
    },
    /**
     * 장애 메시지 클릭 시 해당 이벤트의 관리 대상의 성능운영 > 요약 화면으로 이동한다.
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickEventMessage(row) {
      openFaultAnalysisPopup(this.eventType === 'status' ? row.eventSeqNumber : row.seqNumber);
    },
    /**
     * 이벤트 해제 이력 팝업을 띄운다.
     * @author Ju
     * @param  {[type]} row  [description]
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     */
    clickReleaseHistButton(row, type) {
      const eventHist = clone(row);
      eventHist.targetInfo = this.getTargetInfo(row, null, row.objName);
      this.eventData = eventHist;
      this.releaseHistType = type;
      this.$refs.releaseHistPopup.$refs.slidingPopup.visible = true;
    },
    /**
     * 장애 티켓번호 (그룹 번호) 클릭 이벤트 → 장애 티켓 팝업 제공
     * @param  {[type]} item [description]
     * @param  {[type]} flag [description]
     * @return {[type]}      [description]
     */
    clickTroubleTicketGroupId(troubleTicketGroupId) {
      this.troubleTicketInfo = { troubleTicketGroupId };
      this.$refs.statusPop.open();
    },
    /**
     * '장애티켓 그룹 조회' 팝업 닫기 이벤트이며 파라미터가 존재할 시 '이벤트 상태 이력조회' 팝업을 띄웁니다.
     * @param  {[type]} payload [description]
     * @return {[type]}         [description]
     */
    createPopFromEventStatusPop(payload) {
      // 'clickEventTicketReportPopup' 문자열이 넘어오면 보고서를 띄우고 그외는 상태이력을 띄운다.
      if (payload === 'clickEventTicketReportPopup') {
        this.$refs.reportRefPop.open();
      } else {
        this.eventStatusHistData = payload;
        this.$refs.histRefPop.open();
      }
    },
    /**
     * '이벤트 상태 이력조회' 팝업에서 나갈 경우 다시 '장애티켓 그룹 조회' 팝업으로 돌아갑니다.
     * @return {[type]} [description]
     */
    closeEventStatusHistPopup() {
      this.eventStatusHistPopupVisible = false;
      this.eventTicketStatusVisible = true;
    },
    /**
     * '미처리' 컬럼을 클릭 이벤트
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    clickConfirmManagerStatus(item) {
      let params = {};

      if (isNil(item)) {
        const selectedRows = this.selectedRowArray;
        params.seqNumberList = selectedRows.map((row) => (this.eventType === 'status' ? row.eventSeqNumber : row.seqNumber));
      } else {
        const eventType = this.eventType;
        if (eventType === 'status') {
          params = {
            seqNumber: item.eventSeqNumber,
          };
        } else {
          params = {
            seqNumber: item.seqNumber,
          };
        }
      }
      const target = '이벤트';
      const action = '확인';
      if (params.seqNumber || params.seqNumberList) {
        // 미확인에 대한 장애티켓을 확인으로 처리 - MessageBox 적용 유무?
        TroubleShootingAPI.setConfirmManagerId(params).then((response) => {
          if (response.data.success) {
            this.$message(messageUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(messageUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(messageUtil.getResultMsgData(action, target, false));
        });
      } else {
        this.$message(messageUtil.getResultMsgData(action, target, false));
      }
    },
    /**
     * 핵심장애를 클릭하여 팝업을 띄운다
     * @return {[type]} [description]
     * @author na
     */
    onClickRootCause(row) {
      this.$refs.rootCuaseAnalysisPopup.open(cloneDeep(row));
    },
    /**
     * 이벤트 현황/이력을 엑셀출력한다.
     * @return {[type]} [description]
     * @author jda
     */
    exportExcel() {
      const loadingInstance = this.$loading({
        fullscreen: false,
        target: '.page-container',
        text: '엑셀 파일을 생성중입니다. 잠시만 기다려 주세요.',
      });
      const selectedNode = this.selectedNode;
      const headerSearchParams = this.getHeaderSearchParams();
      if (has(headerSearchParams, 'start')) {
        delete headerSearchParams.start;
      }
      if (has(headerSearchParams, 'limit')) {
        delete headerSearchParams.limit;
      }
      const params = {
        type: selectedNode.type,
        managetypeId: selectedNode.managetypeId,
        treeType: this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical',
        customerId: this.customerId,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        filterParams: this.filterParams,
        headerSearchParams,
        ...headerSearchParams,
      };
      delete params.eventlevelId;
      if (isEqual(params.type, 'group')) {
        if (selectedNode.subType === 'virtual') {
          params.objId = selectedNode.objId;
          params.objtypeId = selectedNode.obj.objtypeId;
          params.subType = selectedNode.subType;
        } else {
          params.managegroupIds = selectedNode.childManagegroupIds;
          if (!isNil(selectedNode.objCompanyId)) {
            params.objCompanyId = selectedNode.objCompanyId;
          }
        }
      } else if (isEqual(params.type, 'obj')) {
        params.objId = selectedNode.obj.objId;
      }

      const excelFunction = this.eventType === 'status' ? EventStatusAPI.getEventStatusExcelName : EventHistAPI.getEventHistExcelName;
      excelFunction(params).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      }).finally(() => {
        loadingInstance.close();
      });
    },
    convertStatusName(row, column, value) {
      if (!isNil(value)) {
        if (row.troubleStatus === 'S' || row.troubleStatus === 'F') {
          return '처리 완료';
        }
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style module>
.click-item {
  color: #1c53ca !important;
}

.click-item:hover {
  text-decoration: underline;
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/EventCommonTable.vue